import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { relations } from 'drizzle-orm';
import { boolean, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { softDelete } from '../columns/soft-delete';
import { setlists } from './setlists';
import { songs } from './songs';

export const setlistSongs = pgTable('setlist_songs', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  order: integer('order').notNull(),
  key: text('key'),
  setlistId: uuid('setlist_id')
    .references(() => setlists.id)
    .notNull(),
  songId: uuid('song_id')
    .references(() => songs.id)
    .notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
  ...softDelete,
});

export const setlistSongsRelations = relations(setlistSongs, ({ one }) => ({
  setlist: one(setlists, {
    fields: [setlistSongs.setlistId],
    references: [setlists.id],
  }),
  song: one(songs, {
    fields: [setlistSongs.songId],
    references: [songs.id],
  }),
}));

export type SetlistSong = InferSelectModel<typeof setlistSongs>;
export type CreateSetlistSongInput = InferInsertModel<typeof setlistSongs>;
export type UpdateSetlistSongInput = Partial<CreateSetlistSongInput>;
